const KL_CART_ADD_FORM_SELECTOR = '[data-type="add-to-cart-form"]';
const KL_CART_DRAWER_SELECTOR = '[data-kl-cart-drawer]';
const KL_CART_DISABLED_SUBMIT_SELECTOR = '[type="submit"][aria-disabled="true"]';
const KL_CART_DRAWER_BUSY_CLASS = 'is-adding';
const KL_CART_DRAWER_OPEN_CLASS = 'active';

let isDrawerOpenedByAdd = false;

function getCanOpenDrawer(drawerElement, isSubmitDisabled) {
  if (!drawerElement) return false;
  if (typeof drawerElement.open !== 'function') return false;

  return !isSubmitDisabled;
}

function getCartDrawer() {
  return document.querySelector(KL_CART_DRAWER_SELECTOR);
}

function setDrawerBusy(isBusy) {
  const drawerElement = getCartDrawer();

  if (!drawerElement) return;

  drawerElement.classList.toggle(KL_CART_DRAWER_BUSY_CLASS, isBusy);
}

function handleCartError() {
  const drawerElement = getCartDrawer();

  if (!drawerElement) return;

  drawerElement.classList.remove(KL_CART_DRAWER_BUSY_CLASS);

  if (isDrawerOpenedByAdd && typeof drawerElement.close === 'function') drawerElement.close();

  isDrawerOpenedByAdd = false;
}

function handleDocumentSubmit(event) {
  try {
    const targetElement = event.target;

    if (!targetElement || typeof targetElement.closest !== 'function') return;

    const formElement = targetElement.closest(KL_CART_ADD_FORM_SELECTOR);

    if (!formElement) return;

    /*
     * hasPendingGate comes from assets/kl-form-gate.js, loaded first. A
     * gate — kl-engrave.js's unfinished-design dialog, kl-gift-wrap.js's
     * add-on fetch — still holding this submit means it has not reached
     * product-form.js yet and may never: the shopper can still cancel out
     * of the engraving dialog. The drawer must not show up early for a
     * submit that might not become an add.
     */
    if (typeof hasPendingGate === 'function' && hasPendingGate(formElement)) return;

    const drawerElement = getCartDrawer();
    const isSubmitDisabled = Boolean(formElement.querySelector(KL_CART_DISABLED_SUBMIT_SELECTOR));

    if (!getCanOpenDrawer(drawerElement, isSubmitDisabled)) return;

    isDrawerOpenedByAdd = !drawerElement.classList.contains(KL_CART_DRAWER_OPEN_CLASS);

    drawerElement.classList.add(KL_CART_DRAWER_BUSY_CLASS);
    drawerElement.open();
  } catch (error) {
    console.debug('kl-cart-instant-open: the drawer could not be brought up early', { error });
  }
}

document.addEventListener('submit', handleDocumentSubmit, true);

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
    setDrawerBusy(false);
    isDrawerOpenedByAdd = false;
  });
  subscribe(PUB_SUB_EVENTS.cartError, handleCartError);
} else {
  console.debug('kl-cart-instant-open: Dawn pubsub was not available, so the drawer opens on the response as before');
  document.removeEventListener('submit', handleDocumentSubmit, true);
}
